import React, { useState } from "react";
import Background from "../../../components/Background";
import BackButton from "../../../components/BackButton";
import CreateEventFrom from "./CreateEventFrom";
import { useSelector } from "react-redux";
import MenteeHeader from "../../../components/MenteeHeader";
import { useNavigate } from "react-router-dom";
import { Box, Container } from "@mui/material";
export default function CreateEvent() {
  const role = useSelector((state) => state.auth?.loginDetails?.profile?.role);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  return (
    <>
      <MenteeHeader
        role={role?.join(", ")}
        searchTerm={searchTerm}
        handleSearchChange={handleSearchChange}
      />
      <Background>
        <Box>
          <Container maxWidth="xl">
            <Box>
              <BackButton
                leftNormal={true}
                onBackStep={() => {
                  navigate(-1);
                  //localStorage.removeItem('eventData')
                }}
              />
            </Box>
            <CreateEventFrom />
          </Container>
        </Box>
      </Background>
    </>
  );
}
